import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "@/services/Store";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faSearch,
	faCaretLeft,
	faCaretRight,
	faTimes,
	faTrash,
	faSortUp,
	faSortDown,
	faQuestionCircle,
	faMap,
	faMapMarker,
	faMapMarkerAlt,
	faSolarPanel,
	faBolt,
	faEnvelope,
	faChevronDown,
	faChevronUp,
	faArrowDown,
	faArrowUp,
	faSpinner,
	faPen
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
	faSearch,
	faCaretLeft,
	faCaretRight,
	faTimes,
	faTrash,
	faSortUp,
	faSortDown,
	faQuestionCircle,
	faMap,
	faMapMarker,
	faMapMarkerAlt,
	faSolarPanel,
	faBolt,
	faEnvelope,
	faChevronDown,
	faChevronUp,
	faArrowDown,
	faArrowUp,
	faSpinner,
	faPen
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
